import React from "react";
import { Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { getSourceSettingsEditorRefreshKey } from "@onetasklist/shared/sources/source-settings";
import type { Status } from "@onetasklist/shared";
import type { ConnectionEditState, ConnectionEditStateUpdater } from "./Connections.ViewModel";
import {
  getSourceSettingsEditor,
  type SourceSettingsEditorProps,
} from "./ConnectionSourceSettingsRegistry";

interface ConnectionSourceSettingsProps {
  editingConnection: ConnectionEditState;
  sourceDisplayName?: string;
  onUpdate: ConnectionEditStateUpdater;
  sectionOffset?: number;
  boardStatuses?: Status[];
}

const SourceSettingsEditorRenderer: React.FC<
  SourceSettingsEditorProps & { sourceTypeId: string }
> = ({ sourceTypeId, ...props }) => {
  const Editor = getSourceSettingsEditor(sourceTypeId);
  if (!Editor) return null;
  // eslint-disable-next-line react-hooks/static-components
  return <Editor {...props} />;
};

export const ConnectionSourceSettings: React.FC<
  ConnectionSourceSettingsProps
> = ({ editingConnection, onUpdate, sectionOffset = 2, boardStatuses = [] }) => {
  const { t } = useTranslation();

  if (editingConnection === null || !editingConnection.isAuthorised) {
    return null;
  }

  const hasSourceSpecificEditor = Boolean(
    getSourceSettingsEditor(editingConnection.sourceTypeId),
  );

  return (
    <>
      <SourceSettingsEditorRenderer
        key={getSourceSettingsEditorRefreshKey(editingConnection)}
        sourceTypeId={editingConnection.sourceTypeId}
        editingConnection={editingConnection}
        onUpdate={onUpdate}
        sectionOffset={sectionOffset}
        boardStatuses={boardStatuses}
      />

      {!hasSourceSpecificEditor && (
        <Text className="connections-page__source-settings-status">
          {t("board.connections.dialog.sourceSettings.notImplemented")}
        </Text>
      )}
    </>
  );
};
